var XPortal = XPortal || {};

XPortal.Localization = (function () {
    var self = {
        localCache: {}
    };
    self.EnsureLocalizedTexts = function (prefix, localizeKeys) {
        const result = {};
        return new Promise(onOk => {
            result.localizedTexts = {};
            const keys = Object.keys(localizeKeys).map(l => prefix + l);
            self.GetLocalizedStrings(...keys).then(function (items) {
                Object.keys(localizeKeys).forEach(l => {
                    const lv = self.GetCachedString(prefix + l, localizeKeys[l]);
                    result.localizedTexts[l] = lv;
                });
                onOk(result);
            });
        });
    };
    self.GetLocalizedStrings = function (...args) {
        var formInfo = $("[name='xprtl']:first");

        var notCachedKeys = [];
        args.forEach(function (key) {
            if (!self.localCache[key])
                notCachedKeys.push(key);
        });
        return new Promise(function (onOk, onErr) {
            if (notCachedKeys.length === 0) return onOk(self.GetCachedResult(args));
            jQuery.ajax({
                data: { Keys: notCachedKeys }
                , url: XPortal.Utils.EnsureInProfile("/umbraco/Surface/CustomUI/GetLocalizedStrings"), method: "POST"
                , headers: { "RequestVerificationToken": XPortal.Main.getAntiForgeryToken(), "xprtl": formInfo ? formInfo.val() : "" }
                , dataType: "json"
            }).then(function (xdata) {
                if (xdata && xdata.length > 0)
                    xdata.forEach(function (i) {
                        self.localCache[i.Key] = i.Value;
                    });
                var r = self.GetCachedResult(args);
                onOk(r);
            }).fail(function (problem) { onErr(problem); });
        });
    };
    self.GetCachedString = function (xkey, xdefault) {
        var r = self.GetCachedResult([xkey])[xkey];
        r = !r || r === xkey ? xdefault : r;
        //console.log("XPortal.Localization.GetCachedString> [" + xkey + "]=[" + r + "]");
        return r;
    };
    self.Get = self.GetCachedString;
    self.GetCachedResult = function (keys) {
        var result = {};
        if (keys) {
            keys = _.isString(keys) ? [keys] : keys;
            keys = _.isArray(keys) ? keys : [keys];
            keys.forEach(function (key) {
                if (_.isString(key)) {
                    var value = self.localCache[key] ? self.localCache[key] : key;
                    result[key] = value;
                }
            });
        }
        return result;
    };

    return self;
}());